module.exports = __webpack_public_path__ + "img/icon-room-hallway.2c87ac6c.svg";